module.exports = __webpack_public_path__ + "07_bob_gold.27f68253.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_bob_gold.png
// module id = iy8k
// module chunks = 0